<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <!-- Dialog export / import -->
          <v-col cols="12">
            <v-btn color="primary" depressed @click="dialogAdd = true">
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
            <v-btn color="yellow-light">
              <v-icon left>mdi-download</v-icon>
              <download-excel
                class="btn btn-default"
                :data="export_data"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
              </download-excel>
            </v-btn>
            <v-btn color="yellow-light" depressed @click="dialogImport = true">
              <v-icon left>mdi-import</v-icon>
              Manage Data By Excel.xls
            </v-btn>
            <v-btn color="yellow-light" @click="getData()"> reload </v-btn>
          </v-col>

          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        label="ชื่อ พนักงาน"
                        v-model="formAdd.empCode"
                        :items="dataItemEmployee"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="รายละเอียด"
                        v-model="formAdd.perEducate_detail"
                        :items="dataItemEmployee"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formAdd.perEducate_date"
                            :rules="nameRules"
                            label="วันที่"
                            outlined
                            dense
                            single-line
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formAdd.perEducate_date"
                          @input="menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogAdd = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="addData(formAdd)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- Import -->
          <v-dialog v-model="dialogImport" persistent max-width="90%">
            <div v-if="dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <v-card v-if="!dataReady">
              <v-card-title>
                <span class="headline">จัดการไฟล์ผ่าน excel.xls</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <input
                        ref="inputFile"
                        type="file"
                        @change="importData"
                        accept=".xls"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          class="elevation-1"
                        ></v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  color="red darken-1"
                  text
                  @click="(dialogImport = false), (dataItemImport = [])"
                >
                  ปิด
                </v-btn>
                <template v-if="!dataItemImportChecKHide">
                  <v-btn
                    elevation="2"
                    color="red"
                    text
                    v-if="!dataReady"
                    @click="importDataApprove('delete')"
                  >
                    ล้างข้อมูลทั้งหมดที่เลือก
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="blue darken-1"
                    text
                    v-if="!dataReady"
                    @click="importDataApprove('update')"
                  >
                    ปรับปรุงข้อมูลที่ตรงกัน
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="green darken-1"
                    text
                    v-if="!dataReady"
                    @click="importDataApprove('add')"
                  >
                    นำเข้าใหม่ทั้งหมด
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end Import -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        label="รหัส พนักงาน"
                        v-model="formUpdate.empCode"
                        disabled
                        outlined
                        dense
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        label="ชื่อ พนักงาน"
                        v-model="formUpdate.empFull_NameTH"
                        disabled
                        outlined
                        dense
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="รายละเอียด"
                        v-model="formUpdate.perEducate_detail"
                        :items="dataItemEmployee"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formUpdate.perEducate_date"
                            :rules="nameRules"
                            outlined
                            dense
                            label="วันที่"
                            single-line
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formUpdate.perEducate_date"
                          @input="menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  text
                  @click="(dialogEdit = false), clear()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="editData(formUpdate)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="!dataReady">
              <v-card-text>
                <v-text-field
                  v-model="searchAll"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogEdit = true), getDataById(item)"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      PK: '',
      path: '/performance_educate/', // Path Model
      // Menu Config
      menu: false,
      menu2: false,
      formAdd: [],
      formUpdate: [],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'การอบรมพัฒนาความสามารถ',
          disabled: true,
          href: '/HRM/EmpPerformance/PerformanceEducate'
        }
      ],
      // End Menu Config
      dataReady: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogImport: false,
      dialogEdit: false,
      dialogAdd: false,
      // END Dialog Config ADD EDIT DELETE
      // Search All
      searchAll: '',
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'ชื่อพนักงาน', value: 'empFull_NameTH' },
        { text: 'รายละเอียด', value: 'perEducate_detail' },
        { text: 'วันที่', value: 'perEducate_date' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'perEducateID', value: 'perEducateID' },
        { text: 'empCode', value: 'empCode' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'Insurance.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        perEducateID: 'perEducateID',
        empCode: 'empCode'
      },
      nameRules: [(v) => !!v || 'Name is required'],
      session: this.$session.getAll(),
      dataItemEmployee: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ]
      // End Export Config
    }
  },
  async mounted () {
    await this.getGetToken(this.DNS_IP)
    let date = new Date()
    this.year = moment().format('YYYY')
    this.month = date.getMonth() + 1
    this.day = date.getDate()
    await this.getData()
    await this.getEmployee()
  },
  methods: {
    async getData () {
      this.dataReady = true
      this.dataItem = []
      this.export_data = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get"
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = false
        })
    },
    async getDataById (item) {
      console.log('formData', item)
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'get?' +
            'perEducateID' +
            '=' +
            item.perEducateID,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('get id : ', response.data)
          this.dataReady = true
          if (response.data) {
            this.formUpdate = response.data[0]
            console.log('getDataById', this.formUpdate)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async clear () {
      await this.getData()
    },
    async getEmployee () {
      this.dataItemEmployee = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/get",
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              // s = d.empFull_NameTH
              s.value = d.empCode
              s.text = '[' + d.empCode + ']' + d.empFull_NameTH
              this.dataItemEmployee.push(s)
            }
          } else {
            this.dataItemEmployee = []
          }
        })
    },
    async addData (dt) {
      console.log('DT', dt)
      console.log('this.year', this.year)
      console.log('this.month', this.month)
      console.log('this.day', this.day)

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let form = {
          CREATE_USER: this.$session.getAll().data.userName,
          LAST_USER: this.$session.getAll().data.userName,
          empCode: dt.empCode,
          perEducate_year: this.year,
          perEducate_day: this.day,
          perEducate_month: this.month,
          perEducate_date: dt.perEducate_date,
          perEducate_detail: dt.perEducate_detail
        }
        console.log('form', form)

        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/performance_educate/add",
            form
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
            this.dialogAdd = false
            this.getData()
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
          })
      })
    },
    async editData (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let form = {
            empCode: dt.empCode,
            perEducate_detail: dt.perEducate_detail,
            perEducate_date: dt.perEducate_date,
            LAST_USER: this.session.data.userName
          }
          console.log('form', form)

          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/performance_educate/edit/" + dt.perEducateID,
              form,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              this.getData()
              this.dataReady = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function 1 : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function 2 : ', error)
        })
    },
    // * Option Import Excel
    // * ตั้งค่าจาก Data
    importData (event) {
      // this.$refs.inputFile.value = null
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            raw: false
          })
          console.log(rowObj)
          this.dataItemImport = rowObj
        })
        if (this.dataItemImport.length === 0) {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          this.$refs.inputFile.value = null
        } else {
          this.dataItemImportChecKHide = false
        }
      }

      reader.readAsBinaryString(input.files[0])
      this.$refs.inputFile.value = null
    },
    importDataApprove (action) {
      console.log('Action', action)
      this.dataReady = true
      var titleMsg = ''
      // var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else if (action === 'delete') {
        titleMsg = 'ท่านต้องการ ลบข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else {
        titleMsg = 'ท่านต้องการ ปรับปรุงข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }
      var countItem = this.dataItemImport.length
      var countLoop = 0
      console.log(countItem)
      console.log(countLoop)
      console.log(this.dataItemImport)

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          console.log(result)
          for (var key in this.dataItemImport) {
            countLoop++
            if (action === 'add') {
              console.log(action)
              await this.importDataAdd(this.dataItemImport[key])
            } else {
              console.log(this.dataItemImport[key].perEducateID)
              await axios
                .get(
                  // eslint-disable-next-line quotes
                  this.DNS_IP +
                    this.path +
                    'get?perEducateID=' +
                    this.dataItemImport[key].perEducateID
                )
                .then(async (response) => {
                  console.log(action)
                  console.log(response)
                  if (action === 'update') {
                    await this.importDataUpdate(this.dataItemImport[key])
                  }
                  if (action === 'delete') {
                    await this.importDataDelete(this.dataItemImport[key])
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                  console.log(
                    'error /PAST/get?perEducateID : ',
                    error
                  )
                })
            }
          }

          if (countLoop === countItem) {
            this.dataItemImport = []
            this.dataReady = false
            this.dialogImport = false
            await this.getData()
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            this.$refs.inputFile.value = null
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
          this.$refs.inputFile.value = null
        })
        .catch((error) => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = false
        })
    },
    async importDataAdd (dt) {
      let ds = {
        empCode: dt.empCode,
        perEducate_year: this.year,
        perEducate_day: this.day,
        perEducate_month: this.month,
        perEducate_date: dt.perEducate_date,
        perEducate_detail: dt.perEducate_detail,
        CREATE_USER: this.$session.getAll().data.userName,
        LAST_USER: this.$session.getAll().data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "add",
          ds
        )
        .then(async (response) => {
          console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function importDataAdd addData : ', error)
        })
    },
    async importDataUpdate (dt) {
      let ds = {
        empCode: dt.empCode,
        perEducate_date: dt.perEducate_date,
        perEducate_detail: dt.perEducate_detail,
        LAST_USER: this.$session.getAll().data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "edit/" + dt.perEducateID,
          ds
        )
        .then(async (response) => {
          console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function importDataUpdate : ', error)
        })
    },
    async importDataDelete (dt) {
      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "delete/" + dt.perEducateID,
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // Debug response
          console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function importDataDelete : ', error)
        })
    }
  }
}
</script>
  <style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/EmpPerformance/PerformanceEducate.vue